import React from 'react';
import "./Specialization.css";

const specializationData = [
    {
        title: "Nature of Business",
        description: "FMCG Trader & Exporter (Food, Beverages & Spirits)",
        image: "/assets/images/home/specialization/business.png"
    },
    {
        title: "Year of Establishment",
        description: "2021",
        image: "/assets/images/home/specialization/calender.png"
    },
    {
        title: "Market Covered",
        description: "Africa (Rwanda, Uganda, DR Congo, etc.) & Global",
        image: "/assets/images/home/specialization/shop.png"
    }
];

function Specialization() {
    return (
        <>
            <section className='Specialization'>
                <div className="container">
                    <div className='Specialization_holder'>
                        <div className="row justify-content-center">
                            {specializationData.map((item, index) => (
                                <div className="col-md-4 col-sm-6 mb-md-0 mb-4" key={index}>
                                    <div className="card_holder">
                                        <div className='img_holder'>
                                            <img
                                                className="Specialization_img"
                                                src={process.env.PUBLIC_URL + item.image}
                                                alt="banner img"
                                            />
                                        </div>
                                        <div className="text_holder">
                                            <h4>{item.title}</h4>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Specialization;
